module.exports = __webpack_public_path__ + "static/media/advincula-product-img@3x.045d01c3.png";